import URL from 'node:url';

import ApolloRun from 'lib/utils/apolloRun';
import botDetector from 'lib/utils/botDetector';
import Guide from 'pages/oneflare.com.au/WinWorkGuide/Guide/Guide';
import { GET_POST, GET_ALL_POSTS } from 'queries/oneflare.com.au/inspiration';

function WinWorkGuidePost(props) {
  return <Guide {...props} />;
}

export async function getServerSideProps(ctx) {
  const { query: params } = ctx;
  await botDetector(ctx.req);
  const apolloRun = new ApolloRun(ctx);
  const isBot = ctx.req?.isBot ?? false;
  const staticRender = ctx.req?.isBotWeCareAbout ?? false;
  const { slug } = params;
  const pageUrl = `/win-work-guide/${slug}/`;
  const renderPageType = null;
  const [allGuideData] = await apolloRun.query(GET_ALL_POSTS, {
    limit: '50',
    categories: '203', // 203 = win work guide category ID in WP
    categoriesExclude: '',
    exclude: '0',
    orderby: 'date',
    order: 'asc',
    sticky: 'false',
    search: ''
  });

  const [guideData] = await apolloRun.query(
    GET_POST,
    params
  );

  if (!guideData?.getPost[0]?.slug) {
    return {
      notFound: true
    };
  }

  const wpPostUri = URL.parse(guideData?.getPost[0]?.link);

  if (wpPostUri?.pathname !== pageUrl) {
    return {
      notFound: true
    };
  }

  return {
    props: {
      params: {
        ...params,
        staticRender,
        isBot
      },
      renderPageType,
      pageUrl: pageUrl.endsWith('/') ? pageUrl.slice(0, -1) : pageUrl,
      wpData: {
        ...(guideData && { guideData: guideData?.getPost[0] }),
        ...(allGuideData && { allGuideData: allGuideData?.getAllPost })
      }
    }
  };
}

export default WinWorkGuidePost;
